window.document.addEventListener("DOMContentLoaded", () => {
  const destination = document.querySelectorAll(".info-tabs__tab .text-columns-icons")[1];
  const source = document.querySelector(".move-to-info-tabs")
  if (destination && source) {
    const classesToRemove = [
      'container--large',
      'container--vertical-space',
      'remove-empty-space'
    ];
    classesToRemove.forEach(className => {
      source.classList.remove(className);
    });
    if (source.children[0]) {
      source.children[0].classList.remove('container--large');
    }
    source.querySelectorAll("img").forEach((img) =>
      img.style.height = '64px'
    );
    destination.appendChild(source);
  }
});
